import type DocumentTypesListView from '@UI/Store/DocumentTypes/Views/DocumentTypesListView';
import type DocumentTypeCountView from '@UI/Store/Indicators/Views/DocumentTypeCountView';

export type RankedTypeCount = {
	readonly documentTypeId: number;
	readonly label: string;
	readonly value: number;
	readonly isArchived: boolean;
	/** Position in the breakdown, 0 for the largest: the bar colour is derived from it. */
	readonly rank: number;
};

/** Types with at least one document, largest first then A→Z: the one order bars and filter share. */
const rankTypeCounts = (
	byType: readonly DocumentTypeCountView[],
	documentTypes: DocumentTypesListView | null,
): readonly RankedTypeCount[] =>
	byType
		.filter((entry) => entry.count > 0)
		.map((entry) => {
			const documentType = documentTypes?.findById(entry.documentTypeId) ?? null;

			return {
				documentTypeId: entry.documentTypeId,
				label: documentType?.label ?? 'Type inconnu',
				value: entry.count,
				isArchived: documentType?.isArchived ?? false,
			};
		})
		.sort((left, right) => right.value - left.value || left.label.localeCompare(right.label, 'fr'))
		.map((entry, rank) => ({ ...entry, rank }));

export default rankTypeCounts;
